import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap-icons/font/bootstrap-icons.css";

import logo from "../../../assets/echovibe.png";
import aibg from "../../../assets/aibg.png";
import { APP_ROUTES } from "../../../constants/appRoutes";
import { isBusinessProfileEmpty } from "../../../utils/isBusinessProfileEmpty";
import { fetchBusinessDetails } from "../../../store/profileSlice";
import Loader from "../../loader/Loader";
import { useAuthModal } from "../../../context/AuthModalContext";
import { ProfileSetupProvider } from "../../../context/ProfileSetupContext";

export default function ProfileCreateLayout({ children, allowExistingProfile = false }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const { data: profileData, loading: profileLoading } = useSelector((state) => state.profile);
  const isGuest = !user;
  const { openAuthModal, closeAuthModal } = useAuthModal();

  useEffect(() => {
    if (!isGuest) return undefined;

    openAuthModal({
      redirectPath: APP_ROUTES.PROFILE_CREATE,
      title: "Sign in to create your profile",
      description: "Log in or register to set up your business profile and unlock the app.",
    });

    return () => {
      closeAuthModal();
    };
  }, [isGuest, openAuthModal, closeAuthModal]);

  useEffect(() => {
    if (user && profileLoading) {
      dispatch(fetchBusinessDetails());
    }
  }, [dispatch, profileLoading, user]);

  useEffect(() => {
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";

    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
  }, []);

  if (!isGuest && profileLoading && !allowExistingProfile) {
    return (
      <div className="relative min-h-screen bg-slate-50">
        <Loader isLoading />
      </div>
    );
  }

  if (!isGuest && !isBusinessProfileEmpty(profileData) && !allowExistingProfile) {
    return <Navigate to={APP_ROUTES.PROFILE} replace />;
  }

  return (
    <ProfileSetupProvider>
      <div className="relative min-h-screen bg-slate-50">
        <div
          className="pointer-events-none fixed inset-0 bg-cover bg-center bg-no-repeat opacity-40"
          style={{ backgroundImage: `url(${aibg})` }}
          aria-hidden
        />
        <div
          className="pointer-events-none fixed inset-0 bg-gradient-to-b from-white/80 via-slate-50/90 to-slate-100/95"
          aria-hidden
        />

        <div className={isGuest ? "pointer-events-none select-none" : ""}>
          <header className="relative z-10 flex justify-center px-4 pt-8 md:pt-12">
            <img src={logo} alt="EzePulse" className="h-10 w-auto md:h-11" />
          </header>

          <main className="relative z-10 px-4 py-6 pb-28 md:py-10 md:pb-10">{children}</main>
        </div>
      </div>
    </ProfileSetupProvider>
  );
}
